import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './index.css';
import App from './App';
import { initAnalytics } from './analytics';

const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
);
root.render(
      <React.StrictMode>
            <App />
      </React.StrictMode>
);

initAnalytics();
